import { crypto } from "./crypto";


export class String extends globalThis.String
{
    static random(length: number, chars: string = this.alphaNumeric): string
    {
        const values = crypto.getRandomValues(new Uint32Array(length));
        const count = chars.length;
        const indices =
            Array.from(values)
                .map(value => Math.floor((value / (2 ** 32)) * count));
        const result =
            indices
                .map(index => chars.charAt(index))
                .join("");
        return result;
    }

    static trimStringAfter(target: string, searchCharacter: string)
    {
        const lastIndex = target.lastIndexOf(searchCharacter);
        return target.substring(0, lastIndex === -1 ? target.length : lastIndex + 1);
    }

    static alphaNumeric = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    static decimals = "0123456789";
    static hexadecimals = "0123456789ABCDEF";
}


declare global
{
    interface String
    {
        at(index: number): string;
    }
}


if (!globalThis.String.prototype.at)
{
    globalThis.String.prototype.at =
        function (this: string, index: number): string
        {
            index = (index < 0) ? this.length + index : index;
            return this.charAt(index);
        };
}
